import { Axis } from "./axis"

/**
 * @memberOf Tee.Chart
 * @constructor
 * @class Contains four axis objects: left, top, right and bottom
 * @property {Boolean} [visible=true] Draws or not all the chart axis objects.
 * @property {Number} [transparency=0] Applies transparency to all axes in chart, from 0 to 1.
 * @param {Tee.Chart} chart The parent chart this axes object belongs to.
 */
export function Axes(chart) {
	this.chart = chart
	this.visible = true

	this.transparency = 0

	/**
	 * @public
	 * @type Tee.Chart.Axis
	 */
	this.left = new Axis(chart, false, false)

	/**
	 * @public
	 * @type Tee.Chart.Axis
	 */
	this.top = new Axis(chart, true, true)

	/**
	 * @public
	 * @type Tee.Chart.Axis
	 */
	this.right = new Axis(chart, false, true)

	/**
	 * @public
	 * @type Tee.Chart.Axis
	 */
	this.bottom = new Axis(chart, true, false)

	this.items = [this.left, this.top, this.right, this.bottom]
	this.each = function (f) {
		for (var t = 0, a, len = this.items.length; t < len; t++) {
			a = this.items[t]
			if (!a) break
			f.call(a)
		}
	}

	/**
	 * Creates and adds a new custom Axis
	 */
	this.add = function (horiz, other) {
		var a = new Axis(chart, horiz, other)
		a.custom = true
		this.items.push(a)
		return a
	}
}
